import React, { useState, useEffect, useRef } from 'react';
import { useParams } from "react-router-dom";

import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import {
    detalheFilialSeller,
    cadastrarFilialSeller,
    editarFilialSeller,
    inativarFilialSeller,
    ativarFilialSeller
} from '../../../../../services/http/SellerAdminstradorService/filialSellerService'
import { trackPromise } from 'react-promise-tracker';
import services from '../../../../../services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { estados, cidadesBrasil } from '../../../../../services/estadosBrasil'
import { buscarEnderecoPorCep } from '../../../../../services/http/cepService';
import { useSnackBar } from '../../../../../hooks/snackBar';

import './styles.scss';

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: 48 * 4.5 + 8,
            width: 250
        }
    },
    getContentAnchorEl: null,
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
    },
    transformOrigin: {
        vertical: "top",
        horizontal: "center"
    },
    variant: "menu"
};

const FormFilialSeller = ({ id, subSellerPage }) => {
    const { addSnackBar } = useSnackBar();
    const { idEmpresa } = useParams();
    const [isFormInvalid, setIsFormInvalid] = useState(false);
    const [idFilialSeller, setidFilialSeller] = useState(null);
    const [voltou, setVoltou] = useState(false);
    const stateRef = useRef();
    stateRef.current = voltou;
    const [cidades, setCidades] = useState([]);
    const [filialSeller, setfilialSeller] = useState({
        codigo: 0,
        cnpj: "",
        ie: "",
        razaoSocial: "",
        nomeFantasia: "",
        tipo: "",
        ativo: false,
        endereco: {
            id: "",
            cep: "",
            logradouro: "",
            numero: "",
            complemento: "",
            bairro: "",
            cidade: "",
            estado: "",
            urlGoogleMaps: ""
        },
        telefone: {
            id: "",
            ddd: "",
            numero: ""
        },
        atendimentoCargaDescarga: {
            horarioAtendimento: "",
            contato: "",
            observacoes: ""
        }
    });

    useEffect(() => {
        if (id != null) {
            setidFilialSeller(id);
            CarregarDetalhesFilialSeller(id);
        }
        var elementAba = document.getElementById('aba-3');
        elementAba.classList.add("active");

        return () => {
            if (!stateRef.current) {
                elementAba.classList.remove("active");
            }
        }
    }, []);

    const voltar = () => {
        setVoltou(true);
        stateRef.current = true;
        subSellerPage(3);
    }

    const enderecoPorCep = (cep) => {
        trackPromise(
            buscarEnderecoPorCep(cep)
                .then(res => {
                    if (res.data.uf) {
                        listarCidadesBrasil(res.data.uf.sigla);

                        setfilialSeller((prevent) => ({
                            ...prevent,
                            endereco: {
                                cep: res.data.cep,
                                logradouro: res.data.logradouro,
                                bairro: res.data.bairro,
                                estado: res.data.uf.sigla,
                                cidade: res.data.cidade.nome
                            }
                        }))
                    }
                })
        ).catch(error => {
            console.log(error);
        })
    }

    const CarregarDetalhesFilialSeller = (id) => {
        trackPromise(
            detalheFilialSeller(id)
                .then(res => {
                    if (res.data) {
                        setfilialSeller(res.data);
                        listarCidadesBrasil(res.data.endereco.estado);
                    } else {
                        if (id) {
                            addSnackBar({ message: 'Não foi possível carregar detalhes do filial', info: 'warning', open: true });
                        }
                    }
                }).catch(error => {
                    addSnackBar({ message: 'Erro ao tentar obter detalhes do filial', info: 'error', open: true });
                })
        )
    }

    const listarCidadesBrasil = (uf) => {
        trackPromise(
            cidadesBrasil(uf)
                .then(res => {
                    if (res.data) {
                        setCidades(res.data);
                    } else {
                        addSnackBar({ message: 'Não foi possível carregar as cidades', info: 'warning', open: true });
                    }
                }).catch(error => {
                    addSnackBar({ message: 'Erro ao carregar cidades', info: 'error', open: true });
                })
        )
    }

    const validarForm = () => {
        var isInvalidForm = false;
        if (!filialSeller.cnpj) isInvalidForm = true;
       /*  if (!filialSeller.ie) isInvalidForm = true;
        if (!filialSeller.im) isInvalidForm = true; */
        if (!filialSeller.razaoSocial) isInvalidForm = true;
        if (!filialSeller.nomeFantasia) isInvalidForm = true;
        if (!filialSeller.endereco.bairro) isInvalidForm = true;
        if (!filialSeller.endereco.numero) isInvalidForm = true;
        if (!filialSeller.endereco.cep) isInvalidForm = true;
        if (!filialSeller.endereco.cidade) isInvalidForm = true;
        if (!filialSeller.endereco.logradouro) isInvalidForm = true;
/*         if (!filialSeller.endereco.urlGoogleMaps) isInvalidForm = true; */

        setIsFormInvalid(isInvalidForm);

        return isInvalidForm;
    }

    const verificarTelefone = () => {
        if (filialSeller.telefone.numero.includes("(")) {
            filialSeller.telefone.ddd = filialSeller.telefone.numero.substring(0, 4).replace("(", "").replace(")", "");
            filialSeller.telefone.numero = filialSeller.telefone.numero.substring(5, filialSeller.telefone.lenght).replace('-', '');
        }
        if (filialSeller.telefone.numero.length == 11) {
            filialSeller.telefone.numero = filialSeller.telefone.numero.substring(2, filialSeller.telefone.numero.length);
        }
    }

    const inativarFilial = () => {
        if (idFilialSeller != undefined) {
            trackPromise(
                inativarFilialSeller(idFilialSeller)
                    .then(res => {
                        if (res.data) {
                            addSnackBar({ message: 'Filial inativado com sucesso', info: 'success', open: true });
                            voltar(3);
                        } else {
                            addSnackBar({ message: 'Não foi inativar filial', info: 'warning', open: true });
                        }
                    }).catch(error => {
                        console.log(error);
                        addSnackBar({ message: 'Erro ao inativar filial', info: 'error', open: true });
                    })
            )
        }
    }

    const ativarFilial = () => {
        if (idFilialSeller != undefined) {
            trackPromise(
                ativarFilialSeller(idFilialSeller)
                    .then(res => {
                        if (res.data) {
                            addSnackBar({ message: 'Filial ativado com sucesso', info: 'success', open: true });
                            voltar(3);
                        } else {
                            addSnackBar({ message: 'Não foi ativar filial', info: 'warning', open: true });
                        }
                    }).catch(error => {
                        console.log(error);
                        addSnackBar({ message: 'Erro ao ativar filial', info: 'error', open: true });
                    })
            )
        }
    }

    const submitfilialSeller = () => {
        if (!validarForm()) {
            filialSeller.cnpj = services.mask.unMask(filialSeller.cnpj)
            filialSeller.endereco.cep = services.mask.unMask(filialSeller.endereco.cep)
            verificarTelefone();

            if (idFilialSeller == null || idFilialSeller == undefined) {
                trackPromise(
                    cadastrarFilialSeller(filialSeller, idEmpresa)
                        .then(res => {
                            if (res.data) {
                                addSnackBar({ message: 'Cadastrado com sucesso', info: 'success', open: true });
                                setidFilialSeller(res.data);
                                voltar(3);
                            } else {
                                res.errors.forEach(element => {
                                    addSnackBar({ message: element.menssagem, info: 'warning', open: true });
                                });
                            }
                        }).catch(error => {
                            addSnackBar({ message: 'Erro ao cadastrar filial', info: 'error', open: true });
                        })
                )
            }
            else {
                filialSeller.id = idFilialSeller;
                trackPromise(
                    editarFilialSeller(filialSeller)
                        .then(res => {
                            if (res.fail == null) {
                                addSnackBar({ message: 'Seller atualizado com sucesso', info: 'success', open: true });
                                voltar(3);
                            } else {
                                res.errors.forEach(element => {
                                    addSnackBar({ message: element.menssagem, info: 'warning', open: true });
                                });
                            }
                        }).catch(error => {
                            console.log(error);
                            addSnackBar({ message: 'Erro ao editar filial', info: 'error', open: true });
                        })
                )
            }

        }

        //if (filialSeller.telefone.numero.length == 9) {
        //    filialSeller.telefone.numero =  filialSeller.telefone.ddd + filialSeller.telefone.numero;
        //}
       
    }

    useEffect(() => {
        //if (filialSeller.telefone.numero != "" && filialSeller.telefone.numero.length == 9) {
        //    filialSeller.telefone.numero = filialSeller.telefone.ddd + filialSeller.telefone.numero;
        //}
    }, [filialSeller]);

    const changesFilial = (value, propertie) => {
        setfilialSeller((prevent) => ({
            ...prevent,
            [propertie]: value
        }));
    }

    const changesEndereco = (value, propertie,) => {
        setfilialSeller((prevent) => ({
            ...prevent,
            endereco: {
                ...prevent.endereco,
                [propertie]: value
            }
        }));
        if (propertie === 'estado') {
            listarCidadesBrasil(value);
        }

    }

    const changesTelefone = (value) => {
        //var ddd = value.substring(0, 4).replace("(", "").replace(")", "");
        //var numero = value.substring(5,value.lenght).replace('-','');
        var ddd = (value.length>=2?value.substring(0,4):value).replace("(", "").replace(")", "");
        var numero = (value.length>=2?value.substring(5,value.length):'').replace('-','').replace(' ','');
        setfilialSeller((prevent) => ({
            ...prevent,
            telefone: {
                ...prevent.telefone,
                numero: numero,
                ddd: ddd
            }
        }));
    }

    const changesAtendimentoCargaDescarga = (value, propertie) => {
        setfilialSeller((prevent) => ({
            ...prevent,
            atendimentoCargaDescarga: {
                ...prevent.atendimentoCargaDescarga,
                [propertie]: value
            }
        }));
    }

    const showfilialField = () => {
        if (idFilialSeller != null || idFilialSeller != undefined) {
            return (<div className="row mt-3">
                <div className="col-sm-5 col-md-5 col-lg-5">
                    <FormControl>
                        <TextField
                            label="#filial"
                            type="text"
                            size="small"
                            id="outlined-basic"
                            variant="outlined"
                            disabled={true}
                            value={`00000${filialSeller.codigo}`}
                        />
                    </FormControl>
                </div>
            </div>)
        }
    }

    return (
        <div className="ml-1 mt20">
            <div className="row"> <div className="col-sm-12 col-md-12 col-lg-12 font"><strong>Dados da Empresa</strong></div></div>
            {showfilialField()}
            <div className="row">
                <div className="col-sm-2 col-md-2 col-lg-2">
                    <FormControl>
                        <TextField
                            required
                            label="CNPJ"
                            placeholder="00000000000000"
                            type="text"
                            size="small"
                            id="outlined-basic"
                            variant="outlined"
                            onChange={event => changesFilial(services.mask.cpfCnpj(event.target.value), 'cnpj')}
                            value={services.mask.cpfCnpj(filialSeller?.cnpj) || ''}
                            helperText={isFormInvalid && !filialSeller?.cnpj && 'Campo obrigatório'}
                            error={isFormInvalid && !filialSeller?.cnpj ? true : false}
                        />
                    </FormControl>
                </div>

                <div className="col-sm-2 col-md-2 col-lg-2">
                    <FormControl>
                        <TextField
                            label="IE"
                            inputProps={{ maxLength: 30 }}
                            placeholder="000000"
                            type="text"
                            size="small"
                            id="outlined-basic"
                            variant="outlined"
                            onChange={event => changesFilial(event.target.value, 'ie')}
                            value={filialSeller?.ie || ''}
                           /*  helperText={isFormInvalid && !filialSeller?.ie && 'Campo obrigatório'}
                            error={isFormInvalid && !filialSeller?.ie ? true : false} */
                        />
                    </FormControl>
                </div>

                <div className="col-sm-2 col-md-2 col-lg-2">
                    <FormControl >
                        <TextField
                            label="IM"
                            inputProps={{ maxLength: 30 }}
                            placeholder="000000"
                            type="text"
                            size="small"
                            id="outlined-basic"
                            variant="outlined"
                            onChange={event => changesFilial(event.target.value, 'im')}
                            value={filialSeller?.im || ''}
                            /* helperText={isFormInvalid && !filialSeller?.im && 'Campo obrigatório'}
                            error={isFormInvalid && !filialSeller?.im ? true : false} */
                        />
                    </FormControl>
                </div>

                <div className="col-sm-3 col-md-3 col-lg-3">
                    <FormControl >
                        <TextField
                            required
                            label="Razão Social"
                            inputProps={{ maxLength: 200 }}
                            placeholder="Informe a Razão Social"
                            type="text"
                            size="small"
                            id="outlined-basic"
                            variant="outlined"
                            onChange={event => changesFilial(event.target.value, 'razaoSocial')}
                            value={filialSeller?.razaoSocial || ''}
                            helperText={isFormInvalid && !filialSeller?.razaoSocial && 'Campo obrigatório'}
                            error={isFormInvalid && !filialSeller?.razaoSocial ? true : false}
                        />
                    </FormControl>
                </div>

                <div className="col-sm-3 col-md-3 col-lg-3">
                    <FormControl>
                        <TextField
                            required
                            label="Nome Fantasia"
                            inputProps={{ maxLength: 150 }}
                            placeholder="Informe o Nome Fantasia"
                            type="text"
                            size="small"
                            id="outlined-basic"
                            variant="outlined"
                            onChange={event => changesFilial(event.target.value, 'nomeFantasia')}
                            value={filialSeller?.nomeFantasia || ''}
                            helperText={isFormInvalid && !filialSeller?.nomeFantasia && 'Campo obrigatório'}
                            error={isFormInvalid && !filialSeller?.nomeFantasia ? true : false}
                        />
                    </FormControl>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-3 col-md-3 col-lg-3"><FormControl >
                    <TextField
                        required
                        label="Telefone"
                        placeholder="00 00000-0000"
                        type="text"
                        size="small"
                        id="outlined-basic"
                        variant="outlined"
                        inputProps={{maxLength:"16"}}
                        onChange={event => changesTelefone(services.mask.phoneoucelularchange(event.target.value))}
                        value={services.mask.phoneoucelular(filialSeller?.telefone.ddd + filialSeller?.telefone?.numero) || ''}
                        helperText={isFormInvalid && !filialSeller?.telefone.numero && 'Campo obrigatório'}
                        error={isFormInvalid && !filialSeller?.telefone.numero ? true : false}
                    />
                </FormControl></div>
                <div className="col-sm-2 col-md-2 col-lg-2"><FormControl >
                    <TextField
                        required
                        label="CEP"
                        placeholder="00000-000"
                        type="text"
                        size="small"
                        id="outlined-basic"
                        variant="outlined"
                        onBlur={event => enderecoPorCep(event.target.value)}
                        onChange={event => changesEndereco(services.mask.cep(event.target.value), 'cep')}
                        value={services.mask.cep(filialSeller?.endereco?.cep) || ''}
                        helperText={isFormInvalid && !filialSeller?.endereco.cep && 'Campo obrigatório'}
                        error={isFormInvalid && !filialSeller?.endereco.cep ? true : false}
                    />
                </FormControl></div>
                <div className="col-sm-5 col-md-5 col-lg-5"><FormControl >
                    <TextField
                        required
                        label="Logradouro"
                        inputProps={{ maxLength: 150 }}
                        placeholder="Informe o endereço"
                        type="text"
                        size="small"
                        id="outlined-basic"
                        variant="outlined"
                        onChange={event => changesEndereco(event.target.value, 'logradouro')}
                        value={filialSeller?.endereco?.logradouro || ''}
                        helperText={isFormInvalid && !filialSeller?.endereco.logradouro && 'Campo obrigatório'}
                        error={isFormInvalid && !filialSeller?.endereco.logradouro ? true : false}
                    />
                </FormControl></div>
                <div className="col-sm-2 col-md-2 col-lg-2"><FormControl >
                    <TextField
                        required
                        label="Número"
                        inputProps={{ maxLength: 10 }}
                        placeholder="000000"
                        type="text"
                        size="small"
                        id="outlined-basic"
                        variant="outlined"
                        onChange={event => changesEndereco(event.target.value, 'numero')}
                        value={filialSeller?.endereco?.numero || ''}
                        helperText={isFormInvalid && !filialSeller?.endereco.numero && 'Campo obrigatório'}
                        error={isFormInvalid && !filialSeller?.endereco.numero ? true : false}
                    />
                </FormControl></div>
            </div>

            <div className="row">

                <div className="col-sm-4 col-md-4 col-lg-4"><FormControl >
                    <TextField
                        label="Complemento"
                        inputProps={{ maxLength: 250 }}
                        placeholder="Informe o complemento"
                        type="text"
                        size="small"
                        id="outlined-basic"
                        variant="outlined"
                        onChange={event => changesEndereco(event.target.value, 'complemento')}
                        value={filialSeller?.endereco?.complemento || ''}
                    />
                </FormControl></div>
                <div className="col-sm-2 col-md-2 col-lg-2"> <FormControl >
                    <TextField
                        required
                        label="Bairro"
                        placeholder="Informe o Bairro"
                        type="text"
                        size="small"
                        id="outlined-basic"
                        variant="outlined"
                        onChange={event => changesEndereco(event.target.value, 'bairro')}
                        value={filialSeller?.endereco?.bairro || ''}
                        helperText={isFormInvalid && !filialSeller?.endereco.bairro && 'Campo obrigatório'}
                        error={isFormInvalid && !filialSeller?.endereco.bairro ? true : false}
                    />
                </FormControl></div>
                <div className="col-sm-2 col-md-2 col-lg-2">  <FormControl >

                    <InputLabel id="demo-simple-select-helper-label">Estado</InputLabel>
                    <Select
                        required
                        className="select"
                        variant="outlined"
                        value={filialSeller?.endereco?.estado || 'selecione'}
                        label="Estado"
                        onChange={event => changesEndereco(event.target.value, 'estado')}
                        MenuProps={MenuProps}
                    >
                        <MenuItem disabled={true} value={"selecione"}>
                            <em>Selecione o estado</em>
                        </MenuItem>

                        {estados.map(es =>
                            <MenuItem value={es}>{es}</MenuItem>
                        )}
                    </Select>

                    {isFormInvalid && !filialSeller?.endereco?.estado &&
                        <FormHelperText>Campo obrigatório</FormHelperText>
                    }
                </FormControl></div>
                <div className="col-sm-4 col-md-4 col-lg-4"> <FormControl >
                    <InputLabel id="demo-simple-select-helper-label">Cidade</InputLabel>
                    <Select
                        required
                        className="select"
                        variant="outlined"
                        value={filialSeller?.endereco?.cidade.toUpperCase() || 'cidade'}
                        label="Cidade"
                        onChange={event => changesEndereco(event.target.value, 'cidade')}
                        MenuProps={MenuProps}
                    >
                        <MenuItem disabled={true} value={"cidade"}>
                            <em>Selecione sua cidade</em>
                        </MenuItem>

                        {cidades.map(filial =>
                            <MenuItem value={filial.nome.toUpperCase()}>{filial?.nome}</MenuItem>
                        )}


                    </Select>
                    {isFormInvalid && !filialSeller?.endereco?.cidade &&
                        <FormHelperText>Campo obrigatório</FormHelperText>
                    }
                </FormControl></div>
            </div>
            <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                    <FormControl>
                        <TextField
                            label="URL Google Maps"
                            placeholder="Informe a URL"
                            type="text"
                            size="small"
                            inputProps={{ maxLength: 500 }}
                            id="outlined-basic"
                            variant="outlined"
                            onChange={event => changesEndereco(event.target.value, 'urlGoogleMaps')}
                            value={filialSeller?.endereco?.urlGoogleMaps || ''}
                           /*  helperText={isFormInvalid && !filialSeller?.endereco.urlGoogleMaps && 'Campo obrigatório'}
                            error={isFormInvalid && !filialSeller?.endereco.urlGoogleMaps ? true : false} */
                        />
                    </FormControl></div>
            </div>
            <div className="row"> <div className="col-sm-12 col-md-12 col-lg-12 font"><strong>Carga Descarga</strong></div></div>

            <div className="row mt-3">
                <div className="col-sm-4 col-md-4 col-lg-4">
                    <TextField
                        label="Horário de atendimento"
                        placeholder="Informe o horário de atendimento"
                        type="text"
                        size="small"
                        id="outlined-basic"
                        variant="outlined"
                        onChange={event => changesAtendimentoCargaDescarga(event.target.value, 'horarioAtendimento')}
                        value={filialSeller?.atendimentoCargaDescarga?.horarioAtendimento}
                    />
                </div>
                <div className="col-sm-4 col-md-4 col-lg-4">
                    <TextField
                        label="Contato"
                        placeholder="Informe o contato"
                        type="text"
                        size="small"
                        id="outlined-basic"
                        variant="outlined"
                        onChange={event => changesAtendimentoCargaDescarga(event.target.value, 'contato')}
                        value={filialSeller?.atendimentoCargaDescarga?.contato}
                    />
                </div>
                <div className="col-sm-4 col-md-4 col-lg-4">
                    <TextField
                        label="Observações adicionais"
                        placeholder="Informe as observações adicionais"
                        type="text"
                        size="small"
                        id="outlined-basic"
                        variant="outlined"
                        onChange={event => changesAtendimentoCargaDescarga(event.target.value, 'observacoes')}
                        value={filialSeller?.atendimentoCargaDescarga?.observacoes}
                    />
                </div>
            </div>


            {/* <div className="col-sm-12 col-md-12 col-lg-12 mt-5 flex flex-end buttons">
                <button className="col-sm-6 col-md-6 col-lg-6 buton-green" onClick={submitfilialSeller}>SALVAR</button>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
                <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-white-black-border" onClick={() => voltar(3)}>CANCELAR</button>
                <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-center-green-black-border" onClick={inativarFilial}>INATIVAR</button>
            </div> */}

            {idFilialSeller &&
                <div className="mt-5">
                    <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
                        <button className="col-sm-6 col-md-6 col-lg-6 buton-green" onClick={() => submitfilialSeller()}>SALVAR</button>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
                        <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-white-black-border" onClick={() => voltar(3)}>CANCELAR</button>
                        {filialSeller?.ativo && <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-center-green-black-border" onClick={inativarFilial} >INATIVAR</button>}
                        {!filialSeller?.ativo && <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-center-green-black-border" onClick={ativarFilial} >ATIVAR</button>}

                    </div>


                </div>}

            {idFilialSeller == null &&
                <div className="mt-5">
                    <div className="col-sm-12 col-md-12 col-lg-12 mt20 flex flex-end buttons">
                        <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-white-black-border" onClick={() => voltar(3)}>CANCELAR</button>
                        <button className="col-sm-3 col-md-3 col-lg-3 mt20 buton-green" onClick={submitfilialSeller}>SALVAR</button>
                    </div>

                </div>}
        </div>
    )
}

export default FormFilialSeller;